import { tsUtils } from '@neo-one/ts-utils';
export const hasOutput = (context, node, type) => tsUtils.type_.hasType(type, (tpe) => isOutput(context, node, tpe));
export const isOnlyOutput = (context, node, type) => tsUtils.type_.isOnlyType(type, (tpe) => isOutput(context, node, tpe));
export const isOutput = (context, node, type) => context.builtins.isInterface(node, type, 'Output');

//# sourceMappingURL=typeTests.js.map
